export const integrationsDirectCdiImportKeysAppGroupId = "/integrations/direct/cdi/import-keys/:app_group_id";
